import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import AuthLayout from '../../components/AuthLayout';
import CompanyRepository from '../../repositories/CompanyRepository';
import { openProviderSession } from '../../services/sessionService';
import { stripSensitiveParams } from '../../utils/urlToken';
import { PROVIDER_BENEFITS } from './ProviderLogin';
import './styles.css';

const MIN_LENGTH = 6;

// Link do e-mail (primeiro acesso ou esqueci a senha): cria a senha e ja entra.
export default function ProviderNewPassword() {
  const history = useHistory();
  const location = useLocation();
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [visible, setVisible] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const linkToken = new URLSearchParams(location.search).get('token');
    if (!linkToken) {
      history.replace('/provider/login');
      return;
    }
    setToken(linkToken);
    // O token sai da barra de endereco e do historico.
    stripSensitiveParams();
  }, [location.search, history]);

  const tooShort = password.length > 0 && password.length < MIN_LENGTH;
  const mismatch = confirm.length > 0 && confirm !== password;
  const valid = password.length >= MIN_LENGTH && confirm === password;

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    setError('');
    try {
      const session = await CompanyRepository.setPassword({ token, password });
      openProviderSession(session);
      window.location.href = '/provider/home';
    } catch (err) {
      const status = err && err.response && err.response.status;
      setError(status === 400 && err.response.data && err.response.data.key === 'password'
        ? err.response.data.message
        : 'Este link expirou ou já foi usado. Peça um novo na tela de login.');
      setBusy(false);
    }
  };

  return (
    <AuthLayout eyebrow='Área da oficina' title='Sua oficina,' highlight='bem avaliada.' benefits={PROVIDER_BENEFITS}>
      <form className='auth-form' onSubmit={handleSubmit} noValidate>
        <header className='auth-form-header'>
          <h2>Criar senha</h2>
          <p>Escolha a senha de acesso da sua oficina.</p>
        </header>
        <div className='auth-field'>
          <div className='auth-field-row'>
            <label htmlFor='pl-new'>Senha nova</label>
            <button type='button' className='auth-link' onClick={() => setVisible((value) => !value)} aria-pressed={visible}>
              {visible ? 'Ocultar' : 'Mostrar'}
            </button>
          </div>
          <input
            id='pl-new'
            type={visible ? 'text' : 'password'}
            autoComplete='new-password'
            value={password}
            maxLength={72}
            aria-invalid={tooShort ? 'true' : undefined}
            onChange={(event) => { setPassword(event.target.value); setError(''); }}
          />
          <p className={`pl-hint${tooShort ? ' is-error' : ''}`}>Mínimo de {MIN_LENGTH} caracteres.</p>
        </div>
        <div className='auth-field'>
          <label htmlFor='pl-confirm'>Repita a senha</label>
          <input
            id='pl-confirm'
            type={visible ? 'text' : 'password'}
            autoComplete='new-password'
            value={confirm}
            maxLength={72}
            aria-invalid={mismatch ? 'true' : undefined}
            onChange={(event) => { setConfirm(event.target.value); setError(''); }}
          />
          {mismatch && <p className='pl-hint is-error'>As senhas não são iguais.</p>}
        </div>
        {error && (
          <p className='pl-error' role='alert'>
            {error} <a className='auth-link' href='/provider/login'>Ir para o login</a>
          </p>
        )}
        <button type='submit' className='auth-submit' disabled={!valid || busy} aria-busy={busy}>
          {busy ? <><span className='auth-spinner' aria-hidden='true' />Salvando…</> : 'Salvar e entrar'}
        </button>
      </form>
    </AuthLayout>
  );
}
